// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"d91234f3b848bee95fa0","452":"861a4b2a3b3c9af51267","453":"c98a6283885784abfa8c","454":"32f270fd4aba00ab71e8","551":"84575844c991ca48c648"}[chunkId] + ".js";
};